<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Roles</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Roles
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="addRoleModal()" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    Add Role
                </button>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Manage Roles</h4>
                </div>

                <div class="card-body">
                    <div class="search-container">
                        <div class="row">
                            <div class="col-lg-9 col-md-8 col-sm-6 d-flex align-items-center">
                                <img src="/images/search.svg" alt="">

                            </div>
                        </div>

                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allRoles"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'action'">
                                <a @click.prevent="addRoleModal(props.row)" href="#">
                                    <i class="feather icon-edit"></i> edit
                                </a> | <a :href="route('admin.roles.permissions.edit', props.row.id)"
                                          class="text-secondary">
                                    <i class="feather icon-edit"></i> view permissions
                                </a>  | <a @click.prevent="showAlert(props.row.id)" class="text-danger">
                                    <i class="feather icon-trash-2"></i> Delete Role
                                </a>
                                <!--                                <a href="#" @click="showAlert(props.row.id)"-->
                                <!--                                   class="text-danger">-->
                                <!--                                    <i class="feather icon-trash-2"></i> delete-->
                                <!--                                </a>-->
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade add-role-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="addRole">
                        <div class="modal-header">
                            <h4 id="myModalLabel1" class="modal-title">
                                {{ this.isEditing ? "Edit Role" : "Add Role" }}
                            </h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Role Name</label>
                                <input type="text" required="required"
                                       class="form-control" v-model="role.name">
                                <div v-if="role.errors.name" class="text-danger text-small">
                                    {{ role.errors.name }}
                                </div>
                            </div>

                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Roles'},
    name: 'RoleIndex',
    props: ['roles'],
    layout: Layout,

    data() {
        return {
            filter: {},
            isLoadingFilter: false,
            allRoles: [],
            role: this.$inertia.form({
                name: null
            }),
            roleId: null,
            isEditing : false,
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },
            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },
            columns: [
                {label: 'S/N', field: 'sn'},
                {label: 'Name', field: 'name', width: '50%'},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
            saving: false,
            searchTerm: '',
        }
    },
    mounted() {
        this.allRoles = this.roles.data;
        this.totalRecords = this.roles.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.roles.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}`;
                let {data: {data: {roles}}} = await axios.get(url);

                this.totalRecords = roles.total;
                this.paginationOptions.perPage = roles.per_page;
                this.allRoles = roles.data
            } catch (e) {
                console.log(e);
            }
        },

        async addRole() {
            this.saving = true;

            if (this.isEditing) {
                this.role.put(route('admin.roles.update', this.roleId), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.allRoles = this.roles.data;
                        $('.add-role-modal').modal('hide');
                        this.saving = false;
                    },
                    onError: () => {
                        this.saving = false;
                    }
                })
            } else {
                this.role.post(route('admin.roles.store'), {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.allRoles = this.roles.data;
                        $('.add-role-modal').modal('hide');
                        this.saving = false;
                    },
                    onError: () => {
                        this.saving = false;
                    }
                })
            }
        },

        async deleteRole(id) {
            this.$inertia.delete(route('admin.roles.destroy', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.$inertia.get(route('admin.roles.index'));
                }
            })
        },

        addRoleModal(role = null) {
            this.role.name = role?.name;
            this.isEditing = !!role
            this.roleId = role?.id

            $('.add-role-modal').modal('show');
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
        showAlert(roleId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure you want to delete this roles?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteRole(roleId)
                }
            });
        },
    }
}
</script>
